import React, { useEffect, useState } from "react";
import { RSelect } from "../Component";

const HospitalHomeCareDropDown = ({ value, isMulti = false, isShowAll = true, onSelect, placeholder, ...props }) => {
  const [list, setList] = useState();

  useEffect(() => {
    return () => {
      setList();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const statusValues = [
      { id: 1, label: "Hospital", value: "HOSPITAL" },
      { id: 2, label: "Care Home", value: "CAREHOME" },
    ];

    if (isShowAll) {
      const allOption = { id: 0, label: "All", value: "" };
      setList([allOption, ...statusValues]);
    } else {
      setList(statusValues);
    }
  }, [isShowAll]);

  return (
    <RSelect
      options={list ?? []}
      isMulti={isMulti}
      placeholder={placeholder}
      value={value ?? null}
      onChange={(e) => {
        onSelect(e);
      }}
      {...props}
    />
  );
};

export default HospitalHomeCareDropDown;
